import Image from 'next/image'
import cl from 'clsx'
import passwordVisibleIcon from '@/public/icons/password-visible.svg'
import passwordHiddenIcon from '@/public/icons/password-hidden.svg'
import styles from './styles.module.css'

/**
 *
 * @param index
 * @param {string} id email
 * @param name
 * @param {string} type
 * @param {string} placeholder
 * @param {string} value
 * @param onChange
 * @param showPassword
 * @param onShowPassword
 * @param {boolean} required
 *
 * @param onKeyDown
 */

const Input = ({
    index,
    id,
    name,
    type,
    placeholder,
    value,
    onChange,
    showPassword,
    onShowPassword,
    required,
    onKeyDown
  }) => {
    const showPasswordIcon = () => {
      return showPassword ? passwordVisibleIcon : passwordHiddenIcon;
    }
    
  return (
    <div className={styles.input__wrapper}>
        <input
            className={styles.input}
            id={id}
            name={name}
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            required={required}
        >
        </input>
        { name === 'password' && <Image onClick={onShowPassword} className={styles.input__password_icon} src={showPasswordIcon()} alt='icon' /> }
    </div>
  )
}

export default Input